// @flow

import styled from 'styled-components';

export default styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  padding: 2rem 0;
  border-top: .3rem solid #ea1d5d;
  z-index: 1;
  & .logo {
    width: 14rem;
    margin-right: 4rem;
    float: right;
    cursor: pointer;
  }
  & .actions {
    float: left;
    & .navbarControlsWrapper, & .navbarUserWrapper {
      float: right;
      margin: auto auto auto 3rem;
      & > div {
        float: right;
      }
      & button {
        border-radius: 4rem;
        width: 5rem;
        height: 5rem;
        overflow: hidden;
        text-align: center;
        display: inline-block;
        float: right;
        margin: 0 .8rem;
        background: rgba(255,255,255,.4);
        outline: none;
        cursor: pointer;
        padding: 0;
        box-sizing: border-box;
        border: .4rem solid transparent;
        &.loginButton {
          width: auto;
          padding: 2rem;
          > span {
            float: left;
            color: #fff;
            font-size: 1.8rem;
            line-height: 0;
            margin: 0 1rem 0 0;
          }
          > i {
            float: right;
          }
        }
        &:hover {
          background: #fff;
          & > i.fa, span {
            color: #020100;
          }
        }
        & i.fa {
          color: #fff;
          font-size: 1.7rem;
          display: block;
          line-height: 0;
        }
        i.fa-search {
          font-size: 2.1rem;
        }
        i.fa-user {
          font-size: 2.3rem;
        }
        i.fa-home {
          font-size: 2.5rem;
        }
        i.fa-angle-left {
          font-size: 3.3rem;
        }
        i.fa-angle-double-down, i.fa-angle-double-up {
          font-size: 3rem;
        }
        &.activeItem, &:hover {
          border: .4rem solid #ea1d5d;
          background: #fff;
          & i.fa, span {
            color: #020100;
          }
        }
      }
    }
    .navbarControlsWrapper {
      > .navbarUserWrapper {
        float: left;
        position: relative;
        margin: 0 1rem 0 6rem;
        .textWrapper {
          > p {
            color: #fff;
            line-height: 0;
            font-weight: bold;
            font-size: 2.5rem;
            margin: 1.5rem 0 1.5rem;
            text-align: right;
          }
          > span {
            color: #f1d830;
            font-size: 1.6rem;
            display: block;
            margin-top: 0;
            text-align: right;
          }
        }
        .user_name {
          margin-top: 2.3rem !important;
        }
        > button {
          float: right;
          position: absolute;
          top: 0;
          right: auto;
          left: -7rem;
          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
`;
